export const getUser = (state) => state.Auth.user;
export const getCategories = (state) => state.Categories.categories;
export const settings = (state) => state.Settings;

// export { region, city };
